import React, { useState, useEffect } from 'react';
import Card from '../../../Shared/Components/Card/Card';

const EcoMemoryGame = ({ updateStats }) => {
    const [cards, setCards] = useState([]);
    const [flippedIndices, setFlippedIndices] = useState([]);
    const [matchedPairs, setMatchedPairs] = useState([]);
    const [moves, setMoves] = useState(0);
    const [isComplete, setIsComplete] = useState(false);

    const cardPairs = [
        { id: 1, icon: '♻️', label: 'Recycle' },
        { id: 2, icon: '🌱', label: 'Plant' },
        { id: 3, icon: '💧', label: 'Save Water' },
        { id: 4, icon: '☀️', label: 'Solar Power' },
        { id: 5, icon: '🚲', label: 'Bike' },
        { id: 6, icon: '🌳', label: 'Trees' },
        { id: 7, icon: '🌍', label: 'Earth' },
        { id: 8, icon: '💚', label: 'Eco Love' }
    ];

    useEffect(() => {
        initializeGame();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const initializeGame = () => {
        const duplicatedCards = [...cardPairs, ...cardPairs]
            .map((card, index) => ({ ...card, uniqueId: index }))
            .sort(() => Math.random() - 0.5);
        setCards(duplicatedCards);
        setFlippedIndices([]);
        setMatchedPairs([]);
        setMoves(0);
        setIsComplete(false);
    };

    useEffect(() => {
        if (flippedIndices.length === 2) {
            const [first, second] = flippedIndices;
            if (cards[first].id === cards[second].id) {
                setMatchedPairs([...matchedPairs, cards[first].id]);
                setFlippedIndices([]);
            } else {
                setTimeout(() => setFlippedIndices([]), 800);
            }
            setMoves(moves + 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [flippedIndices]);

    useEffect(() => {
        if (matchedPairs.length === cardPairs.length && matchedPairs.length > 0) {
            setIsComplete(true);
            updateStats('gamesPlayed', 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchedPairs]);

    const handleCardClick = (index) => {
        if (flippedIndices.length < 2 &&
            !flippedIndices.includes(index) &&
            !matchedPairs.includes(cards[index].id)) {
            setFlippedIndices([...flippedIndices, index]);
        }
    };

    const isCardFlipped = (index) => {
        return flippedIndices.includes(index) || matchedPairs.includes(cards[index].id);
    };

    return (
        <Card>
            <div style={{ padding: '32px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
                    <div>
                        <h4 style={{ color: '#1f2937', marginBottom: '8px' }}>Match the Eco Actions</h4>
                        <p style={{ color: '#6b7280', margin: 0 }}>Find all matching pairs to complete the game</p>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: '0.85rem', color: '#666', fontWeight: '600' }}>MOVES</div>
                        <div style={{ fontSize: '2rem', fontWeight: '700', color: '#11998e' }}>{moves}</div>
                    </div>
                </div>

                {isComplete && (
                    <div style={{
                        background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                        borderRadius: '12px',
                        padding: '24px',
                        marginBottom: '24px',
                        color: 'white',
                        textAlign: 'center'
                    }}>
                        <h3 style={{ marginBottom: '8px' }}>🎉 Congratulations!</h3>
                        <p style={{ marginBottom: '16px', opacity: 0.9 }}>You completed the game in {moves} moves!</p>
                        <button
                            onClick={initializeGame}
                            style={{
                                background: 'rgba(255, 255, 255, 0.2)',
                                border: '2px solid rgba(255, 255, 255, 0.3)',
                                borderRadius: '8px',
                                padding: '10px 24px',
                                color: 'white',
                                fontWeight: '600',
                                cursor: 'pointer',
                                backdropFilter: 'blur(10px)'
                            }}
                        >
                            Play Again
                        </button>
                    </div>
                )}

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                    gap: '16px',
                    maxWidth: '800px',
                    margin: '0 auto'
                }}>
                    {cards.map((card, index) => (
                        <div
                            key={card.uniqueId}
                            onClick={() => handleCardClick(index)}
                            style={{
                                aspectRatio: '1',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '12px',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                transformStyle: 'preserve-3d',
                                transform: isCardFlipped(index) ? 'rotateY(180deg)' : 'rotateY(0deg)',
                                background: isCardFlipped(index)
                                    ? 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)'
                                    : '#f3f4f6',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                fontSize: '3rem'
                            }}
                            onMouseEnter={(e) => {
                                if (!isCardFlipped(index)) {
                                    e.currentTarget.style.transform = 'translateY(-4px)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!isCardFlipped(index)) {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                }
                            }}
                        >
                            {isCardFlipped(index) ? (
                                <div style={{
                                    transform: 'rotateY(180deg)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    <span>{card.icon}</span>
                                    <span style={{
                                        fontSize: '0.75rem',
                                        fontWeight: '600',
                                        color: 'white',
                                        textAlign: 'center'
                                    }}>
                                        {card.label}
                                    </span>
                                </div>
                            ) : (
                                '?'
                            )}
                        </div>
                    ))}
                </div>

                {!isComplete && (
                    <div style={{ textAlign: 'center', marginTop: '24px' }}>
                        <button
                            onClick={initializeGame}
                            style={{
                                background: '#f3f4f6',
                                border: '1px solid #e5e7eb',
                                borderRadius: '8px',
                                padding: '10px 24px',
                                color: '#6b7280',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = '#e5e7eb';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = '#f3f4f6';
                            }}
                        >
                            Reset Game
                        </button>
                    </div>
                )}
            </div>
        </Card>
    );
};

export default EcoMemoryGame;
